// JsFromRoutes CacheKey c0ac23c68ad34bdbb44624bc60bdbaf5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  index: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/statistics/bookings"),
}
